import { Container } from "@mui/material";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";

const TermsofUse = () => {
  return (
    <>
      <section className="terms-conditions">
        <Container>
          <div className="terms-content">
            <div className="section-title">
              <h2 className="text-center">TERMS OF USE</h2>
              <p>
                This document (“Terms of Use”) is an electronic record in terms
                of Information Technology Act, 2000 and rules thereunder, and
                other applicable law. This electronic record is generated by a
                computer system and does not require any physical or digital
                signatures.
              </p>
              <p>
                This document is published in accordance with the provisions of
                Rule 3(1) of the Information Technology (Intermediaries
                Guidelines and Digital Media Ethics Code) Rules, 2021 that
                requires publishing of the rules and regulations, privacy policy
                and terms for access or usage of the website
                [https://packpro.swiggy.com/] (“Platform”).
              </p>
              <h3>1.GENERAL</h3>
              <p>
                The Platform is made available by Swiggy Limited (“Company”,
                “we”, “us” and “our”), a company established under the laws of
                India, having its registered oﬃce at No.55 Sy No.8-14, Ground
                Floor, I&J Block, Embassy Tech Village, Outer Ring Road,
                Devarbisanahalli, Bengaluru 560103.
              </p>
              <p>
                “Merchants” refer to persons who offer and list their products/
                services which can be viewed by users (“Users”) on the Platform.
                Merchants and Users are collectively referred to as “You” /
                “Your”.
              </p>
              <p>
                The term “Services” refers to any services offered by Platform
                including but not limited to:
              </p>
              <ul style={{ listStyle: "lower-roman" }}>
                <li>
                  Providing access to the Platform, with the included tools,
                  menus, software, options, features and functionality to allow
                  Merchants to list products and services through the Platform;
                </li>
                <li>
                  Providing data analytics services to Merchants to help them
                  track and evaluate customer interactions and transactions that
                  take place on the Platform; and
                </li>
                <li>
                  Providing access to Users to look for Merchants by name,
                  specialty, and geographical area, or any other criteria that
                  may be developed and made available by Platform (collectively,
                  “Service(s)”).
                </li>
              </ul>
              <p>
                For the purposes of these Terms of Use, unless deﬁned hereunder,
                all capitalized terms shall have the meaning ascribed to them in
                the Privacy Policy.
              </p>
              <p>
                Please read these Terms of Use along with Privacy Policy
                available at https://packpro.swiggy.com/ carefully before you
                access the Platform or use the Services. If you do not agree to
                these Terms of Use, please do not use the Platform or avail our
                Services. By even merely accessing the Platform, you shall be
                contracting with and you signify your acceptance to this Terms
                and other policies (including but not limited to the Privacy
                Policy) as posted on the Platform, and as amended from time to
                time.
              </p>
              <p>
                As a Merchant, you agree to comply with your obligations under
                these Terms.
              </p>
              <h3>2.AMENDMENTS</h3>
              <p>
                The Company reserves the right to change or modify these Terms
                of Use, or any policy or guideline of the Platform, including
                the Privacy Policy, at any time and in its sole discretion. Any
                changes or modifications will be effective immediately upon
                posting the revisions on the Platform. While the Company may
                periodically inform you of material changes to the Terms of Use,
                you are responsible for checking this page regularly to note any
                changes. Your continued use of the Platform or the Services
                means you accept and agree to the updated Terms of Use.
              </p>
              <p>
                By (i) using the Platform or availing any of our Services, (ii)
                visiting the Platform, you agree that you have read, understood,
                and agreed to be bound by these Terms of Use, the Privacy
                Policy, and any other applicable rules, guidelines, policies,
                terms, and conditions under applicable law(s) in India and other
                jurisdictions. These documents shall be considered part of these
                Terms of Use.
              </p>
              <p>
                The Platform is operated, and Services are provided, in
                compliance with Indian laws. The Company shall not be liable to
                provide any Services to users outside India. If you access our
                Services from locations outside India, you do so at your own
                risk and are solely responsible for complying with applicable
                local laws.
              </p>

              <h3>3.SERVICES</h3>
              <strong>For Merchants:</strong>
              <p>
                The Company offers you various tools and services. Any new
                features or tools that are added to the current Services will
                also be subject to these Terms and you are encouraged to visit
                this page and review them periodically. Your continued use of
                the Platform or the Services, or operations on the Platform,
                means that you accept and agree to the Terms and their extension
                to such new features and Services. Further, some of the Services
                may be provided by third party Partners of the Company. Such
                third party Partners may have alternative or additional terms
                and conditions that may be applicable to you (“Additional
                Terms”). You are responsible for reviewing and agreeing to such
                terms and conditions.
              </p>
              <p>
                Additionally, in the event of a conﬂict between the Terms of Use
                and the Additional Terms, the conditions set out in the
                Additional Terms will prevail in relation to that particular
                Service.
              </p>
              <strong>For Users:</strong>
              <p>
                When you check services/products of any Merchant on the
                Platform, you are bound by the Terms and conditions of such
                Merchant, Terms of Use and other Policies of the Platform. The
                Company has no control over products or services, content,
                quality or the level of service made available through Platform
                by such Merchants and does not have any privity with you. The
                authenticity, accuracy or genuineness of the products and
                services made available by the Merchants is the sole
                responsibility of the relevant Merchant. Furthermore, We provide
                no warranty with respect to delivery of service/products or any
                communications between Merchants and Users.
              </p>
              <h3>4.ELIGIBILITY OF USE</h3>
              <p>
                Persons who are "incompetent to contract" within the meaning of
                the Indian Contract Act, 1872 including minors, un-discharged
                insolvent etc. are not eligible to use the Platform. Only
                individuals who are 18 years of age or older may use the
                Platform and avail Services. If you are under 18 years of age
                and you wish to download, install, access or use the Platform or
                our Services, your parents or legal guardian must acknowledge
                and agree to the Terms and Privacy Policy. Should your parents
                or legal guardian fail to agree or acknowledge the Terms and
                policies, you shall immediately discontinue its use. reserves
                the right to terminate your Account and / or deny access to the
                Platform if it is brought to ’s notice that you are under the
                age of 18 years.
              </p>
              <h3>5.USER STORIES</h3>
              <p>
                By using this Platform, you agree that any information shared by
                you with Platform or with any Merchant will be subject to our
                Privacy Policy.
              </p>
              <p>
                You are solely responsible for the content that you choose to
                submit for publication on the Platform, including any stories or
                recommendations (“Content”) relating to Merchants. The role of
                Platform in publishing Content is restricted to that of an
                ‘intermediary’ under the Information Technology Act, 2000.
                Platform disclaims all responsibility with respect to the
                contents of Content, and its role with respect to such content
                is restricted to its obligations as an ‘intermediary’ under the
                said Act. shall not be liable to pay any consideration to any
                User for re-publishing any content across any of its platforms.
              </p>
              <p>
                Your publication of stories/ testimonies on the Platform is
                governed by Clause 8 of these Terms. Without prejudice to the
                detailed terms stated in Clause 8, you hereby agree not to post
                or publish any content on the Platform that (a) infringes any
                third-party intellectual property or publicity or privacy
                rights, or (b) violates any applicable law or regulation,
                including but not limited to the IT Rules and SPI Rules.
                Platform, at its sole discretion, may choose not to publish your
                stories, if so required by applicable law, and in accordance
                with Clause 8 of these Terms. You agree that Platform may
                contact you through telephone, email, SMS, or any other
                electronic means of communication for the purpose of:
              </p>
              <ul style={{ listStyle: "lower-roman" }}>
                <li>
                  Obtaining feedback in relation to Platform or Merchant’s
                  services/products; and/or
                </li>
                <li>
                  Obtaining feedback in relation to any Merchants listed on the
                  Platform; and/or
                </li>
                <li>
                  Resolving any complaints, information, or queries by Merchants
                  regarding your Content; and you agree to provide your fullest
                  co-operation further to such communication by Platform.
                </li>
              </ul>
              <h3>6.TERMS OF USE</h3>
              <ul style={{ listStyle: "lower-roman" }}>
                <li>
                  Platform, directly and indirectly, displays information
                  regarding the Merchant profiles, contact details, and
                  Services/ products offered. Platform reserves the right to
                  take down any Merchant’s profile as well as the right to
                  display the profile of the Merchant, with or without notice to
                  the concerned Merchant. This information is collected for the
                  purpose of facilitating interaction with the End-Users and
                  other Users. If any information displayed on the Website in
                  connection with you and your profile is found to be incorrect,
                  you are required to inform Platform immediately to enable
                  Platform to make the necessary amendments.
                </li>
                <li>
                  Platform shall not be liable and responsible for the ranking
                  of the Merchant on external websites and search engines if
                  any.
                </li>
                <li>
                  Platform shall not be responsible or liable in any manner to
                  the Users for any losses, damage, injuries or expenses
                  incurred by the Users as a result of any disclosures or
                  publications made by , where the User has expressly or
                  implicitly consented to the making of disclosures or
                  publications by Platform.
                </li>
                <li>
                  Merchant explicitly agree that Platform reserves the right to
                  publish the Content provided by Merchant to a third party
                  including content platforms.
                </li>
                <li>
                  You as a Merchant hereby represent and warrant that you will
                  use the Services in accordance with applicable law. Any
                  contravention of applicable law as a result of your use of
                  these Services is your sole responsibility, and Platform
                  accepts no liability for the same.
                </li>
                <li>
                  “Content” may be created by the Users of Platform
                  (“Platform”) and the clients of Merchants, including the
                  End-Users. As a platform, Platform does not take
                  responsibility for Content and its role with respect to
                  Content is restricted to that of an ‘intermediary’ under the
                  Information Technology Act, 2000.
                </li>
                <li>
                  Platform reserves the right to collect feedback and Content
                  for all the Merchants listed on the Platform.
                </li>
                <li>
                  Platform shall have no obligation to pre-screen, review, flag,
                  filter, modify, refuse or remove any or all Content from any
                  Service, except as required by applicable law.
                </li>
                <li>
                  You understand that by using the Services you may be exposed
                  to Content or other content that you may find offensive or
                  objectionable. shall not be liable for any effect on
                  Merchant’s business due to Content of a negative nature. In
                  these respects, you may use the Services at your own risk.
                  however, as an ‘intermediary, takes steps as required to
                  comply with applicable law as regards the publication of
                  Content.
                </li>
                <li>
                  Platform will take down information under standards consistent
                  with applicable law, and shall in no circumstances be liable
                  or responsible for Content, which has been created by the
                  Users. The principles set out in relation to third party
                  content in the terms of Service for the Platform shall be
                  applicable mutatis mutandis in relation to Content posted on
                  the Platform.
                </li>
                <li>
                  If Platform determines that you have provided inaccurate
                  information or enabled fraudulent feedback, Platform reserves
                  the right to immediately suspend any of your accounts with
                  Platform and makes such declaration on the website alongside
                  your name/your clinics name as determined by Platform for the
                  protection of its business and in the interests of Users.
                </li>
                <li>
                  Platform has designed the relevance algorithm in the best
                  interest of the End-User and may adjust the relevance
                  algorithm from time to time to improve the quality of the
                  results given to the patients. It is a pure proprietary
                  algorithm which cannot be altered for specific Merchant. shall
                  not be liable for any effect on the Merchant’s business
                  interests due to the change in the Relevance Algorithm.
                </li>
                <li>
                  Your use of each Service confers upon you only the rights and
                  obligations relating to such Service, and not to any other
                  service that may be provided by Platform.
                </li>
                <li>
                  You represent and warrant that you will use these Services in
                  accordance with applicable law. Any contravention of
                  applicable law as a result of your use of these Services is
                  your sole responsibility, and Platform accepts no liability
                  for the same.
                </li>
                <li>
                  As a valuable partner on our platform we want to ensure that
                  the Merchant experience on the Platform booking platform is
                  beneficial to both, Merchant and their Users.
                </li>
                <li>
                  Merchant understands that, Platform shall not be liable, under
                  any event, for any comments or feedback given by any of the
                  Users in relation to the Services provided by Merchant. The
                  option of publishing or modifying or moderating or masking
                  (where required by law or norm etc.) the feedback provided by
                  Users shall be solely at the discretion of Platform.
                </li>
                <li>
                  The Merchant is and shall be duly registered, licensed and
                  qualified to provide services to Users as per applicable
                  laws/regulations/guidelines set out by competent authorities
                  and the Merchant shall not be part of any arrangement which
                  will prohibit him/her from providing services within the
                  territory of India. The Merchant shall at all times ensure
                  that all the applicable laws that govern the Merchant shall be
                  followed and utmost care shall be taken in terms of the
                  consultation/ services being rendered.
                </li>
              </ul>

              <h3>7.USER ACCOUNT, PASSWORD AND SECURITY</h3>
              <p>
                <strong>For Users:</strong>
              </p>
              <p>
                You may access the services hosted on the Platform by directly
                accessing the Services offered by way of registering on Platform
                by making an account or by registering using your account on
                third party social media platforms (“SNS”) (including, but not
                limited to, Facebook); each such account, a “Third Party
                Account”.
              </p>
              <p>
                You represent that you are entitled to disclose your Third Party
                Account login information to us and/or grant us access to your
                Third Party Account (including, but not limited to, for use for
                the purposes described herein), without breach by you of any of
                the terms and conditions that govern your use of the applicable
                Third Party Account and without obligating us to pay any fees or
                making us subject to any usage limitations imposed by such third
                party service providers.
              </p>
              <p>
                By granting us access to any Third Party Accounts, you
                acknowledge and agree that we may access, display, and make
                available any content or information that you have provided on
                your Third Party Account (“SNS Content”) on the Platform via
                your Account.
              </p>
              <p>
                Unless otherwise speciﬁed in these Terms, all SNS Content, if
                any, will be considered to be your content for all purposes of
                these Terms of Use. Depending on the Third Party Accounts, you
                choose, and subject to the privacy settings that you have set in
                such Third Party Accounts, personally identiﬁable information
                that you post to your Third Party Accounts will be available on
                and through your Account on the Platform.
              </p>
              <p>
                Please note that if a Third Party Account or associated service
                becomes unavailable or our access to such Third Party Account is
                terminated by the third party service provider, then SNS Content
                will no longer be available on and through the Platform.
              </p>
              <p>
                You agree to provide accurate, current and complete information
                during the registration process and update such information to
                keep it accurate, current and complete (“Account Information”).
              </p>
              <p>
                We reserve the right to suspend or terminate your Account and
                your access to the Services (i) if any information provided
                during the registration process or thereafter proves to be
                inaccurate, not current or incomplete; (ii) if it is believed
                that your actions may cause legal liability for you, other users
                or us; and/or (iii) if you are found to be non-compliant with
                the Terms of Use or other policies.
              </p>
              <p>
                You will be responsible for maintaining the conﬁdentiality of
                the Account Information and are fully responsible for all
                activities that occur under your Account. You agree to (a)
                immediately notify Company of any unauthorized use of your
                Account or Account Information or any other breach of security,
                non-compliance with any applicable laws, rules, regulations and
                guidelines as may be notiﬁed from time to time; and (b) ensure
                that you exit / log out from your Account at the end of each
                session. Company cannot and will not be liable for any loss or
                damage arising from your failure to comply with this Paragraph
                5. You may be held liable for losses incurred by Company or any
                other user of or visitor to the Platform due to authorized or
                unauthorized use of your Account as a result of your failure in
                keeping your Account Information secure and conﬁdential or
                otherwise. You shall ensure that the Account Information
                provided by you for registering on the Platform is true,
                complete, accurate and up to date. Use of another user's Account
                Information for availing the services offered by Company is
                expressly prohibited. Company will not be responsible for any
                ﬁnancial loss, inconvenience or mental agony resulting from
                misuse of your ID/password/credit card number/Account details
                for using the Platform.
              </p>

              <h3>8.COMPANY’S RIGHTS</h3>
              <p>
                The Company strives to provide you with a wide range of features
                and functionalities for availing our Services on the Platform.
                Not all Services or features will be available to all users at
                all times and we are under no obligation to make any Services or
                features available in any jurisdiction.
              </p>
              <p>
                Except where prohibited in these Terms of Use or by applicable
                law, we reserve the right to modify the Services or any part
                thereof for any reason, without prior notice to you and at any
                time.
              </p>
              <p>As a Merchant, you understand and agree that:</p>
              <ul style={{ listStyle: "auto" }}>
                <li>
                  The Company does not pre-screen any materials, products or
                  contents that you offer or display on the Platform
                  (collectively “Materials”) and it is in our sole discretion to
                  refuse or remove any Materials or part of it, including if we
                  determine in our sole discretion that the goods or services
                  that you offer through the Services, or the Materials uploaded
                  or posted on the Platform, violate these Terms of Use. All
                  commercial terms such as price, date, time of
                  provision/delivery of services are as per
                  principal-to-principal bipartite contractual obligations
                  between the Merchant and Users. You agree that the Company
                  does not have control of or liability for the products or
                  services that are listed/ offered through the Platform. The
                  Company does not guarantee the identity of any third parties,
                  nor does it ensure that a Customer who uses the Platform or a
                  third party will complete a transaction.
                </li>
                <li>
                  We reserve the right to provide our Services to your
                  competitors and make no promise of exclusivity.
                </li>
                <li>
                  In the event of a dispute regarding Account ownership, we
                  reserve the right to request documentation to determine or
                  conﬁrm Account ownership. Documentation may include, but is
                  not limited to, a scanned copy of your business license,
                  government issued photo ID, the last four digits of the credit
                  card on ﬁle, or conﬁrmation of your status as an employee of
                  an entity.
                </li>
                <li>
                  The Company reserves the right to determine, in our sole
                  discretion, rightful Account ownership and transfer an Account
                  to the rightful account owner. If we are unable to reasonably
                  determine the rightful account owner, without prejudice to our
                  other rights and remedies, the Company reserves the right to
                  temporarily suspend or disable an Account until resolution has
                  been determined between the disputing parties.
                </li>
                <li>
                  If you make any payments in relation to our Services you agree
                  as follows.
                  <ul style={{ listStyle: "lower-roman" }}>
                    <li>
                      In order to process the payments for any Services that you
                      avail, you may be required to provide details of your bank
                      account, credit card number, etc. The online fee payments
                      made by you are processed with the support and services of
                      the banks/payment gateways/payment aggregators/ third
                      parties and the Company does not receive the ﬁnancial
                      information provided by you to these banks/payment
                      gateways/payment aggregators/ third parties. The Company
                      is not responsible for any loss or damage caused to you
                      during this process as these banks/payment
                      gateways/payment aggregators/ third parties are beyond the
                      control of the Company and subject to their respective
                      policies. There are no applicable payment charges levied
                      on any transactions. The Merchant agrees that the Merchant
                      will be responsible to review and agree to the Additional
                      Terms of such third party payment service providers and
                      the Company will have no liability in this regard.
                    </li>
                    <li>
                      Settlement- The Merchant agrees that all settlements by
                      the Company will be processed subsequent to the rendering
                      of services by the Merchant ordered by the Customer,
                      subject to no claims from the Users confirming otherwise.
                    </li>
                    <li>
                      Taxes- Each Merchant / third party service provider is
                      solely responsible for payment of all taxes, legal
                      compliances, statutory registrations and reporting. The
                      Company shall in no way be responsible for any of the
                      taxes except for its own taxes. Further please note that
                      all fees are exclusive of applicable taxes.
                    </li>
                    <li>
                      Security Measures- The payment made for every transaction
                      is done through API integration. Moreover, you may also
                      check our Privacy Policy to understand how the Company
                      uses the conﬁdential information provided by Merchants.
                    </li>
                    <li>
                      The Company reserves the right to modify the fee structure
                      by providing notification on the Platform which shall be
                      considered as valid and agreed communication. The Company
                      shall not be responsible if some purchase is not
                      registered or is lost due to any network issues/problems
                      such as breakdown of machinery, unclear/ disruption in the
                      network or non-receipt of payment from banks/payment
                      gateways/payment aggregators/third parties and/or the
                      cost(s) charged by the network operator(s). However, the
                      Company shall work towards the best interest of the
                      Merchant.
                    </li>
                    <li>
                      Dispute- Any dispute in connection to the third-parties
                      services shall be settled between the Merchants and the
                      respective third parties, including without limitations,
                      banks/payment gateways/payment aggregators/network
                      operators without involving the Company.
                    </li>
                  </ul>
                </li>
              </ul>
              <h3>9.NO ENDORSEMENT</h3>
              <p>
                We do not endorse any Merchant on the Platform or any of our
                Partners. In addition, although these Terms of Use require you
                to provide accurate information, we do not attempt to conﬁrm,
                and do not conﬁrm if it is purported identity. We will not be
                responsible for any damage or harm resulting from your
                interactions with other users of the Platform.
              </p>
              <p>
                By using the Services, you agree that any legal remedy or
                liability that you seek to obtain for actions or omissions of
                other users or other third parties will be limited to a claim
                against the particular users or other third parties who caused
                you harm and you agree not to attempt to impose liability on, or
                seek any legal remedy from us with respect to such actions or
                omissions.
              </p>
              <h3>10.USER OBLIGATIONS</h3>
              <p>
                Subject to compliance with these Terms of Use, Company grants
                you a personal, non- exclusive, non-transferable, limited
                privilege to access and use the Platform and the Services
                provided herein. You agree to use the Services, Platform, and
                the materials provided therein only for purposes that are
                permitted by: (a) the Terms of Use; and (b) in accordance with
                applicable law, regulation or generally accepted practices or
                guidelines in the relevant jurisdictions. You agree and
                acknowledge:
              </p>
              <ul style={{ listStyle: "auto" }}>
                <li>
                  not to access (or attempt to access) the Platform and the
                  materials or Services by any means other than through the
                  interface that is provided by the Company.
                </li>
                <li>
                  not to use any automated means such as data scraper,
                  deep-link, robot, spider or other automatic device, program,
                  algorithm or methodology, or any similar or equivalent manual
                  process to access the Platform, or Services for any purpose.
                </li>
                <li>
                  not to use any automated device to access, acquire, copy or
                  monitor any portion of the Platforms, or in any way reproduce
                  or circumvent the navigational structure of the Platform, to
                  obtain or attempt to obtain any materials, documents or
                  information through any means not speciﬁcally made available
                  through the Platform.
                </li>
                <li>
                  to operate the Platform and use the Services in accordance
                  with applicable laws and you will be responsible for obtaining
                  all necessary consents, permissions, licenses, etc. that may
                  be necessary or that may be held by you in your use of the
                  Service and your performance of obligations under the Terms.
                </li>
                <li>
                  You will be responsible for obtaining all necessary consents
                  from Users to collect, process and disclose their data for
                  Platform providing services if required.
                </li>
                <li>
                  is just a facilitator and any contract of sale/ services made
                  through the Services is directly between Merchant and the
                  Customer. You are the service provider of all services you
                  sell/ provide through the Platform. You are responsible for
                  the creation and operation of your Materials, the goods and
                  services that you may sell/ provide through Platform. You
                  represent and warrant that your Materials and the goods and
                  services you sell/ provide through the Services will be true,
                  accurate, and complete, and will not violate any applicable
                  laws, regulations or rights of third parties. For the
                  avoidance of doubt, the Company will not be the seller or
                  merchant on record.
                </li>
                <li>
                  that you will comply with the list of permitted and restricted
                  goods and services that can be offered through the Platform.
                </li>
                <li>
                  that you are solely responsible for the goods or services that
                  you may sell/ provide through the Platform (including
                  description, price, fees, defects, required legal disclosures,
                  regulatory compliance, offers or promotional content),
                  including compliance with any applicable laws or regulations.
                </li>
                <li>
                  that you will not publish any news or current affairs or the
                  business carried out through the Platform.
                </li>
                <li>
                  that you will not discriminate against any Users based on
                  race, religion, caste, national origin, disability, sexual
                  orientation, sex, marital status, gender identity, age or any
                  other metric which is deemed to be unlawful under applicable
                  laws. Any credible proof of such discrimination, including any
                  refusal to provide goods or services based on the above
                  metrics, whether alone or in conjunction with any other
                  metric, whether lawful or unlawful, shall render you liable to
                  lose access to the Platform immediately. You will not have any
                  claim towards, and we will not have any liability towards any
                  termination which is undertaken as a result of the
                  aforementioned event;
                </li>
                <li>
                  you shall at all times ensure full compliance with the
                  applicable provisions, as amended from time to time, of (a)
                  the Information Technology Act, 2000 and the rules thereunder;
                  (b) all applicable domestic laws, rules and regulations
                  (including the provisions of any applicable exchange control
                  laws or regulations in force); and (c) international laws,
                  foreign exchange laws, statutes, ordinances and regulations
                  regarding your use of our Platform and our Services and any
                  sale of products or services through Platform. You shall not
                  engage in any transaction in an item or service, which is
                  prohibited by the provisions of any applicable law including
                  exchange control laws or regulations for the time being in
                  force. You acknowledge that the Services may include
                  functionality for uploading or providing suggestions,
                  recommendations, feedback, stories, photos, documents, logos,
                  products, loyalty programs, promotions, advertisements and
                  other materials or information, which will also be included
                  within the scope of Materials you upload on the Platform. You
                  grant us and our subsidiaries, aﬃliates, and successors a
                  worldwide, non- exclusive, royalty-free, fully-paid,
                  transferable, irrevocable, perpetual, and sub-licensable right
                  to use, reproduce, modify, adapt, publish, prepare derivative
                  works of, distribute, publicly perform, and publicly display
                  your Materials throughout the world in any media for any
                  reason, including to provide, promote, and/or incorporate into
                  the Services. You retain all rights in your Materials, subject
                  to the rights you granted to us in these Terms. You may modify
                  or remove your Materials via your Account or by terminating
                  your Account, but your Materials may persist in historical,
                  archived or cached copies and versions thereof available on or
                  through the Services. You hereby undertake to ensure that the
                  Materials are not offensive and in accordance with applicable
                  laws.
                </li>
              </ul>
              <p>Further, youu undertake not to:</p>
              <ul style={{ listStyle: "auto" }}>
                <li>
                  Host, display, upload, modify, publish, transmit, update or
                  share Materials which:
                  <ul style={{ listStyle: "lower-roman" }}>
                    <li>
                      amounts to stealing and/or publishing of information
                      belonging to others and to which you do not have any right
                      (including but not limited to personal information,
                      non-personal information and payment information) without
                      requisite consent or a license;
                    </li>
                    <li>
                      impersonates any person, including the Company, our
                      affiliates, our designated partners, our designated
                      representatives, our employees, or another user/player;
                    </li>
                    <li>
                      is illegal, misleading, fraudulent, invasive of another’s
                      privacy (including bodily privacy), harmful, threatening,
                      abusive, blasphemous, insulting or harassing (including on
                      the basis of gender), tortious, disparaging, defamatory,
                      vulgar, sexually explicit, pornographic, paedophilic,
                      libelous, obscene, hateful, racially or ethnically
                      objectionable, inappropriate, profane, indecent, or
                      relating to or encouraging money laundering or gambling,
                      or otherwise inconsistent with or contrary to the laws in
                      force;
                    </li>
                    <li>
                      which shows any individual in full or partial nudity or
                      shows or depicts any individual in any sexual act or
                      conduct, or is in the nature of impersonation in
                      electronic form including through artificially morphed
                      images;
                    </li>
                    <li>
                      infringes any intellectual property rights, including
                      patent, trademark, moral rights, trade secret, copyright,
                      service marks or other proprietary rights, of any
                      individual /entity;
                    </li>
                    <li>
                      takes advantage of, exploits, deceives or misleads any
                      other user about the origin of the message or knowingly
                      and intentionally communicates any information which is
                      patently false or untrue, and is written or published in
                      any form, with the intent to mislead or harass a person,
                      entity or agency (especially for financial gain or to
                      cause any injury to any person) (as determined in our sole
                      discretion);
                    </li>
                    <li>
                      contains software viruses or any other computer code,
                      files or programs designed to interrupt, destroy or limit
                      the functionality of any computer resource;
                    </li>
                    <li>
                      violate any applicable law, rule, or regulation in
                      connection with your access or use of the Platform or
                      Services or otherwise;
                    </li>
                    <li>is harmful to minors; or</li>
                    <li>
                      threatens the unity, integrity, defense, security or
                      sovereignty of India, friendly relations with foreign
                      States, or public order, is against decency or morality,
                      results in contempt of court, or causes incitement to the
                      commission of any offence or prevents investigation of any
                      offence or is insulting any other nation.
                    </li>
                  </ul>
                </li>
                <li>
                  You shall not delete or modify any content of the Platform,
                  including but not limited to, legal notices, disclaimers or
                  proprietary notices such as copyright or trademark symbols,
                  logos, that you do not own or have express permission to
                  modify.
                </li>
                <li>
                  You shall not use any "deep-link", "page-scrape", "robot",
                  "spider" or other automatic device, program, algorithm or
                  methodology, or any similar or equivalent manual process, to
                  access, acquire, copy or monitor any portion of the Platform
                  or any Materials, or in any way reproduce or circumvent the
                  navigational structure or presentation of the Platform or any
                  Materials, to obtain or attempt to obtain any materials,
                  documents or information through any means not purposely made
                  available through the Platform. We reserve our right to
                  prohibit any such activity.
                </li>
                <li>
                  You shall not attempt to gain unauthorized access to any
                  portion or feature of the Platform, or any other systems or
                  networks connected to the Platform or to any server, computer,
                  network, or to any of the services offered on or through the
                  Platform, by hacking, "password mining" or any other
                  illegitimate means.
                </li>
                <li>
                  You shall not probe, scan or test the vulnerability of the
                  Platform or any network connected to the Platform nor breach
                  the security or authentication measures on the Platform or any
                  network connected to the Platform. You may not reverse
                  look-up, trace or seek to trace any information on any other
                  user of or visitor to Platform, including any account on the
                  Platform not owned by you, to its source, or exploit the
                  Platform or any service or information made available or
                  offered by or through the Platform, in any way where the
                  purpose is to reveal any information, including but not
                  limited to personal identiﬁcation or information, other than
                  your own information, as provided for by the Platform.
                </li>
                <li>
                  You shall not make any negative, denigrating or defamatory
                  statement(s) or comment(s) about us or the brand name or
                  Platform name used by us including the name '', or otherwise
                  engage in any conduct or action that might tarnish the image
                  or reputation, of or Merchant on the Platform or otherwise
                  tarnish or dilute any 's service marks, trade name and/or
                  goodwill associated with such trade or service marks, as may
                  be owned or used by us or any of our aﬃliates and Group. You
                  agree that you will not take any action that imposes an
                  unreasonable or disproportionately large load on the
                  infrastructure of the Platform or ’ systems or networks, or
                  any systems or networks connected to .
                </li>
                <li>
                  You agree not to use any device, software or routine to
                  interfere or attempt to interfere with the proper working of
                  the Platform or any transaction being conducted on the
                  Platform, or with any other person's use of the Platform.
                </li>
                <li>
                  You may not forge headers or otherwise manipulate identiﬁers
                  in order to disguise the origin of any message or transmittal
                  you send to us on or through the Platform or any service
                  offered on or through the Platform. You may not pretend that
                  you are, or that you represent, someone else, or impersonate
                  any other individual or entity.
                </li>
                <li>
                  You may not use the Platform or any content on the Platform
                  for any purpose that is unlawful or prohibited by these Terms
                  of Use, or to solicit the performance of any illegal activity
                  or other activity that infringes the rights of and/or others.
                </li>
                <li>
                  In order to allow us to use the information supplied by you,
                  without violating your rights or any laws, you agree to grant
                  us a non-exclusive, worldwide, perpetual, irrevocable,
                  royalty- free, sub-licensable (through multiple tiers) right
                  to exercise the copyright, publicity, database rights or any
                  other rights you have in your information, in any media now
                  known or not currently known, with respect to your
                  Information. We will only use your information in accordance
                  with these Terms of Use and Privacy Policy applicable to use
                  of the Platform.
                </li>
                <li>
                  You understand that we have the right at all times to disclose
                  any information (including the identity of the persons
                  providing information or materials on the Platform) as
                  necessary to satisfy any law, regulation or valid governmental
                  request. This may include, without limitation, disclosure of
                  the information in connection with investigation of alleged
                  illegal activity or solicitation of illegal activity or in
                  response to a lawful court order or subpoena. In addition, We
                  can (and you hereby expressly authorize us to) disclose any
                  information about you to law enforcement or other government
                  oﬃcials, as we, in our sole discretion, believe necessary or
                  appropriate in connection with the investigation and/or
                  resolution of possible crimes, especially those that may
                  involve personal injury.
                </li>
                <li>
                  We reserve the right, but have no obligation, to monitor the
                  Materials posted on the Platform. shall have the right to
                  remove or edit any content that in its sole discretion
                  violates, or is alleged to violate, any applicable law or
                  either the spirit or letter of these Terms of Use.
                  Notwithstanding this right, YOU REMAIN SOLELY RESPONSIBLE FOR
                  THE CONTENT OF THE MATERIALS YOU POST ON THE PLATFORM. Please
                  be advised that such content posted does not necessarily
                  reﬂect ’ views. In no event shall Platform assume or have any
                  responsibility or liability for any content posted or for any
                  claims, damages or losses resulting from use of content and/or
                  appearance of content on the Platform. You hereby represent
                  and warrant that you have all necessary rights in and to all
                  content which you provide and all information it contains and
                  that such content shall not infringe any proprietary or other
                  rights of third parties or contain any libelous, tortious, or
                  otherwise unlawful information.
                </li>
                <li>
                  Your correspondence or business dealings with Users or
                  Partners, including payment and delivery of products or
                  services, and any other terms, conditions, warranties or
                  representations associated with such dealings, are solely
                  between you and such Customer / Partner. We shall not be
                  responsible or liable for any loss or damage of any sort
                  incurred as the result of any such dealings or as the result
                  of such interaction.
                </li>
                <li>
                  It is possible that other users (including unauthorized users
                  or ‘hackers’) may post or transmit offensive or obscene
                  materials on the Platform and that you may be involuntarily
                  exposed to such offensive and obscene materials. It also is
                  possible for others to obtain personal information about you
                  due to your use of the Platform, and that the recipient may
                  use such information to harass or injure you. We do not
                  approve of such unauthorized uses, but by using the Platform
                  you acknowledge and agree that we are not responsible for the
                  use of any personal information that you publicly disclose or
                  share with others on the Platform. Please carefully select the
                  type of information that you publicly disclose or share with
                  others on the Platform.
                </li>
                <li>
                  Platform shall have all the rights to take necessary action
                  and claim damages that may occur due to your
                  involvement/participation in any way on your own or through
                  group/s of people, intentionally or unintentionally in
                  DoS/DDoS (Distributed Denial of Services), hacking, pen
                  testing attempts without our prior consent or a mutual legal
                  agreement.
                </li>
                <li>
                  You shall not violate any applicable laws or regulations for
                  the time being in force within or outside India;
                </li>
                <li>
                  You shall not violate the Terms of Use, including but not
                  limited to any applicable Additional Terms contained herein or
                  elsewhere; and
                </li>
                <li>
                  You shall not reverse engineer, modify, copy, distribute,
                  transmit, display, perform, reproduce, publish, license,
                  create derivative works from, transfer, or sell any
                  information or software obtained from the Platform
                </li>
              </ul>
              <h3>11.NOTICE AND TAKE DOWN POLICY TEMPLATE AND PROCEDURES</h3>
              <p>
                If any person believes that their work (as included on the
                Platform) has been copied, displayed, or distributed in a way
                that constitutes copyright infringement, you must provide a
                written communication (by email or regular mail) that sets out
                the information speciﬁed in the list below. Please note that you
                will be liable for damages (including costs and lawyer's fees)
                if you materially misrepresent that material is infringing your
                intellectual property right(s). Accordingly, if you are not sure
                if you are the proprietor of the intellectual property right(s),
                we suggest that you ﬁrst contact a lawyer. To expedite our
                ability to process your request, please use the following
                format:
              </p>
              <ul style={{ listStyle: "auto" }}>
                <li>
                  Identify with suﬃcient detail the protected work that you
                  believe has been infringed. This includes identiﬁcation of the
                  identiﬁcation of what material in such work(s) is claimed to
                  be infringed and that such use is not covered by fair use or
                  any other available defense. Posts must be referenced by
                  either the dates in which they appear or by the permalink of
                  the post on the Platform or Services. Include the URL to the
                  concerned material infringing your intellectual property
                  right(s) [URL of a website or URL to a post, with title, date,
                  name of the emitter], or link to initial post with suﬃcient
                  data to ﬁnd it;
                </li>

                <li>
                  Identiﬁcation of the material that is claimed to be infringing
                  or to be the subject of infringing activity and that is to be
                  removed or access to which is to be disabled, and information
                  reasonably suﬃcient to permit to locate the material;
                </li>

                <li>
                  Information reasonably suﬃcient to permit to contact the
                  complaining party, such as an address telephone number, and,
                  if available, an email address at which the complaining party
                  may be contacted;
                </li>

                <li>
                  The following mandatory statement: "I have a good faith belief
                  that use of the material in the manner complained of is not
                  authorized by the intellectual property right(s) owner, its
                  agent, or the law";
                </li>

                <li>
                  The following mandatory statement: "I undertake that the
                  information in the notiﬁcation is accurate, and that I am the
                  intellectual property right(s) owner or authorized to act on
                  behalf of the owner of an exclusive intellectual property
                  right(s) that is allegedly infringed";
                </li>

                <li>
                  An undertaking that you will ﬁle an infringement suit in the
                  competent court against the person responsible for uploading
                  the infringing copy and produce the orders of the competent
                  court having jurisdiction, within a period of 21 (twenty-one)
                  days from the receipt of the notice by us.
                </li>

                <li>
                  Sign the document with either your physical or electronic
                  signature; and
                </li>
                <li>
                  Send the written communication to: <br />
                  Email to brand-protection@swiggy.in <br />
                  Format of notice of infringement:{" "}
                  <div style={{ paddingLeft: "30px" }}>
                    To,
                    <br /> Swiggy Limited, <br />
                    No.55 Sy No.8-14, Ground Floor, I&J Block, Embassy Tech
                    Village, Outer Ring Road, Devarbisanahalli, Bengaluru 560103{" "}
                    <br />
                    I, {`< >`}of {`< >`}do solemnly and sincerely declare as
                    follows: <br />
                    1. I am the owner of certain intellectual property rights,
                    said owner being named {`("IP Owner")`}. <br />
                    2. I have a good faith belief that use of the material in
                    the manner complained of is not authorized by the
                    intellectual property right{`(s)`} owner, its agent, or the
                    law therefore infringe the IP Owner's rights. Please
                    expeditiously remove or disable access to the material
                    claimed to be infringing. <br />
                    3. I may be contacted at: <br />
                    Name <br />
                    Designation/Title & Company <br />
                    Postal Address
                    {`(with Pin code)`} <br />
                    Email Address {`(correspondence)`} Telephone/Fax <br />I
                    swear, under penalty of perjury, that the information in the
                    notiﬁcation is accurate, and that I am the intellectual
                    property right{`(s)`} owner or am authorized to act on
                    behalf of the owner of an exclusive intellectual property
                    right(s) that is allegedly infringed and I make this
                    declaration conscientiously believing it to be true and
                    correct. Declared by {"< >"} on {"< >"} at {"< >"}.<br />
                    <br />
                    Truthfully, <br />
                    Signature
                  </div>
                </li>
              </ul>
              <p>
                <strong>Important Note:</strong>
              </p>
              <ul style={{ listStyle: "none" }}>
                <li>
                  (a) shall be unable to process requests which do not specify
                  exact product IDs or URLs.
                </li>
                <li>(b) shall not consider an incomplete request.</li>
                <li>
                  (c) 's response to such request will include removing or
                  disabling access to material claimed to be the subject of
                  infringing activity.
                </li>
              </ul>

              <p>
                Please note that we only investigate notices or claims of
                infringement of copyright if such notices are received from the
                owner of copyright or from a duly authorized licensee.
              </p>

              <ul style={{ listStyle: "auto" }}>
                <li>
                  If you believe that the notice received from any third party
                  alleging infringement of their copyrighted work(s) is baseless
                  or erroneous, you may send a counter-notice containing the
                  following information to us:
                  <ul style={{ listStyle: "none" }}>
                    <li>
                      a. details of the notice received from the third party;
                    </li>
                    <li>
                      b. a point wise reply to each of the claims of the third
                      party;
                    </li>
                    <li>
                      c. proof of your ownership in the copyrighted work(s); and
                    </li>
                  </ul>
                  <p>
                    Your name, address, telephone number, and email address, a
                    statement that you consent to the jurisdiction of the courts
                    from where you have received the notice and a statement that
                    you will accept service of process from the person who
                    provided notiﬁcation of the alleged infringement.
                  </p>
                  <p>
                    If a counter-notice is received by us, the Company may send
                    a copy of the counter-notice to the original complaining
                    party. Unless the complainant ﬁles an action seeking a court
                    order against the user to whom the notice was issued within
                    21 (twenty-one) days of receiving a counter-notice or
                    provides a court order to the Company within such time
                    period, the removed content may be replaced, or access to it
                    restored.
                  </p>
                </li>
              </ul>
              <h3>12.INDEMNIFICATION AND LIMITATION OF LIABILITY</h3>
              <p>
                You agree to indemnify, defend and hold harmless Company
                including but not limited to its aﬃliates, vendors,
                representatives, directors, agents and employees from and
                against any and all losses, liabilities, claims, damages,
                demands, costs and expenses (including legal fees and
                disbursements in connection therewith and interest chargeable
                thereon) asserted against or incurred by Company that arise out
                of, result from, or may be payable by virtue of, any breach or
                non- performance of any representation, warranty, covenant or
                agreement made or obligation to be performed by you pursuant to
                these Terms of Use. Further, you agree to hold Company harmless
                against any claims made by any third party due to, or arising
                out of, or in connection with, your use of the Platform, any
                claim that your material caused damage to a third party, your
                violation of the Terms of Use, or your violation of any rights
                of another, including any intellectual property rights.
              </p>
              <p>
                Notwithstanding anything to contrary, Company's entire liability
                to you under this Terms of Use or otherwise shall be to the
                extent of refund of the money charged from you for Services
                availed by you, under which the unlikely liability arises. In no
                event shall Company, its oﬃcers, directors, employees, partners
                or suppliers be liable to you, or any third party for any
                special, incidental, indirect, consequential or punitive damages
                whatsoever, including those resulting from loss of use, data or
                proﬁts, whether or not foreseeable or whether or not Company has
                been advised of the possibility of such damages, or based on any
                theory of liability, including breach of contract or warranty,
                negligence or other tortious action, or any other claim arising
                out of or in connection with your use of or access to the
                Platform, Services or content on the Platform.
              </p>
              <p>
                Company is not responsible for any non-performance or breach of
                any contract entered into between users and third party service
                providers. Company cannot and does not guarantee that the
                concerned users and/or third party service providers will
                perform any transactions that are entered into on the Platform.
              </p>
              <p>
                Company shall not and is not required to mediate or resolve any
                dispute or disagreement between users and third party service
                providers. Company does not, at any point of time during any
                transaction between users and third party service providers on
                the Platform come into or take possession of any of the services
                offered by third party service providers nor does it at any
                point gain title to or have any rights or claims over the
                services offered by third party service providers to users.
              </p>
              <p>
                At no time shall Company hold any right, title or interest over
                the services/products sold through the Platform, nor shall
                Company have any obligations or liabilities in respect of such
                contract entered into between users and third party service
                providers. The limitations and exclusions in this section apply
                to the maximum extent permitted by applicable law.
              </p>
              <h3>13.VIOLATION OF TERMS OF USE</h3>
              <p>
                You agree that Company may, in its sole discretion and without
                prior notice, terminate your access to the Platform and block
                your future access to the Platform, if Company determines that
                you have violated these Terms of Use or Additional Terms. You
                also agree that any violation by you of these Terms of Use will
                constitute an unlawful and unfair business practice, and will
                cause irreparable harm to Company, for which monetary damages
                would be inadequate, and You consent to Company obtaining any
                injunctive or equitable relief that Company deems necessary or
                appropriate in such circumstances. These remedies are in
                addition to any other remedies Company may have at law or in
                equity.You agree that Company may, in its sole discretion, and
                without prior notice, terminate your access to the Platform, for
                cause, which includes (but is not limited to):
              </p>

              <ul style={{ listStyle: "auto" }}>
                <li>
                  requests by law enforcement or other government agencies;
                </li>
                <li>a request by you (self- initiated account deletions);</li>
                <li>
                  discontinuance or material modiﬁcation of the Platform or any
                  Service offered on or through the Platform; or unexpected
                  technical issues or problems.If Company does take any legal
                  action against you as a result of your violation of these
                  Terms of Use, Company will be entitled to recover from you,
                  and you agree to pay, all reasonable attorneys' fees and costs
                  of such action, in addition to any other relief granted to
                  Company.
                </li>
              </ul>
              <h3>14.TERMINATION</h3>
              <p>
                The Terms of Use will continue to apply until terminated by
                either you or Company as set forth below. If you want to
                terminate your agreement with the Company, You may do so by (i)
                not accessing the Platforms; or (ii) closing your Accounts.
                Company may, at any time, with or without notice, terminate the
                Terms of Use (or portion thereof, such as any individual
                Additional Terms) with you if:
              </p>

              <ul>
                <li>
                  You breach any of the provisions of the Terms of Use, the
                  Privacy Policy or any other terms, conditions, or policies
                  that may be applicable to you from time to time (or have acted
                  in a manner that clearly shows that You do not intend to, or
                  are unable to, comply with the same);
                </li>
                <li>
                  Company is required to do so by law (for example, where the
                  provision of the services hereunder, to you is, or becomes,
                  unlawful);
                </li>
                <li>
                  The provision of the Services to you, by Company is, in
                  Company's opinion, no longer commercially viable;
                </li>
                <li>
                  Company has elected to discontinue, with or without reason,
                  access to the Platform, the Services (or any part thereof); or
                </li>
                <li>
                  Company may also terminate or suspend all or a portion of your
                  account or access to the Services with or without reason.
                </li>
              </ul>

              <p>
                Except as may be set forth in the Terms of Use applicable to a
                particular service, termination of your Account may include:
              </p>

              <ul style={{ listStyle: "lower-roman" }}>
                <li>
                  removal of access to all offerings within the Platform or with
                  respect to the Services;
                </li>
                <li>
                  deletion of your materials and Account Information, including
                  your personal information, log-in ID and password, and all
                  related information, ﬁles and materials associated with or
                  inside your Account (or any part thereof); and
                </li>
                <li>
                  barring of further use of the Services.You agree that all
                  terminations shall be made in Company's sole discretion and
                  that Company shall not be liable to you or any third party for
                  any termination of your Account (and accompanying deletion of
                  your Account Information), or your access to the Platform or
                  the Services.
                </li>
              </ul>

              <p>
                Notwithstanding the foregoing, these Terms of Use will survive
                indeﬁnitely unless and until Company chooses to terminate them.
                If you or Company terminates your use of the Platform, Company
                may delete any content or any other materials relating to your
                use of the Platform and Company will have no liability to you or
                any third party for doing so.
              </p>
              <h3>
                15.RELATIONSHIP WITH OPERATORS IF THE PLATFORM IS ACCESSED ON
                MOBILE DEVICES
              </h3>
              <ul style={{ listStyle: "auto" }}>
                <li>
                  In the event the Platform is accessed on a mobile device, it
                  is not associated, aﬃliated, sponsored, endorsed or in any way
                  linked to any platform operator, including, without
                  limitation, Apple, Google, or Android (each being an
                  “Operator”).
                </li>
                <li>
                  Your download, installation, access to or use of the Platform
                  is also bound by the terms and conditions of the Operator.
                </li>
                <li>
                  You acknowledge that these Terms of Use are concluded between
                  you and only, and not with an Operator, and we, not those
                  Operators, are solely responsible for the Platform and the
                  content thereof to the extent speciﬁed in these Terms of Use.
                </li>
                <li>
                  The license granted to you for the Platform is limited to a
                  non-transferable license to use the Platform on a mobile
                  device that you own or control and as permitted by these Terms
                  of Use.
                </li>
                <li>
                  We are solely responsible for providing any maintenance and
                  support services with respect to the Platform as required
                  under applicable law. You and we acknowledge that an Operator
                  has no obligation whatsoever to furnish any maintenance and
                  support services with respect to the Platform.
                </li>
                <li>
                  You and we acknowledge that, in the event of any third party
                  claim that the Platform or your use of the Platform infringes
                  that third party's intellectual property rights, we, not the
                  relevant Operator, will be solely responsible for the
                  investigation, defense, settlement and discharge of any such
                  intellectual property infringement claim.
                </li>
                <li>
                  You must comply with any applicable third party terms of
                  agreement when using the Platform (e.g. you must ensure that
                  your use of the Platform is not in violation of your mobile
                  device agreement or any wireless data service agreement).
                </li>
                <li>
                  You and we acknowledge and agree that the relevant Operator,
                  and that Operator's subsidiaries, are third party beneﬁciaries
                  of these Terms of Use, and that, upon your acceptance of these
                  Terms of Use, that Operator will have the right (and will be
                  deemed to have accepted the right) to enforce these Terms of
                  Use against you as a third party beneﬁciary thereof.
                </li>
              </ul>
              <h3>16.DISCLAIMERS</h3>
              <p>
                THE PLATFORM MAY BE UNDER CONSTANT UPGRADES, AND SOME FUNCTIONS
                AND FEATURES MAY NOT BE FULLY OPERATIONAL. COMPANY WILL NOT BE
                LIABLE FOR ANY LOSS THAT YOU MAY INCUR AS A CONSEQUENCE OF
                UNAUTHORIZED USE OF YOUR ACCOUNT OR ACCOUNT INFORMATION IN
                CONNECTION WITH THE PLATFORM, SERVICES OR CONTENT ON THE
                PLATFORM, EITHER WITH OR WITHOUT YOUR KNOWLEDGE. FURTHER,
                COMPANY SHALL NOT BE HELD RESPONSIBLE FOR NON-AVAILABILITY OF
                THE PLATFORM DURING PERIODIC MAINTENANCE OPERATIONS OR ANY
                UNPLANNED SUSPENSION OF ACCESS TO THE PLATFORM THAT MAY OCCUR
                DUE TO TECHNICAL REASONS OR FOR ANY REASON BEYOND COMPANY'S
                CONTROL. THE USER UNDERSTANDS AND AGREES THAT ANY MATERIAL OR
                DATA DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE PLATFORM, IS
                DONE ENTIRELY AT THEIR OWN DISCRETION AND RISK AND THEY WILL BE
                SOLELY RESPONSIBLE FOR ANY DAMAGE TO THEIR COMPUTER SYSTEMS OR
                LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL OR
                DATA. COMPANY ACCEPTS NO LIABILITY FOR ANY ERRORS OR OMISSIONS,
                WITH RESPECT TO ANY INFORMATION PROVIDED TO YOU WHETHER ON
                BEHALF OF ITSELF OR THIRD PARTIES. YOU EXPRESSLY AGREE THAT YOUR
                USE OF THE PLATFORM IS AT YOUR RISK.
              </p>
              <p>
                WE EXPRESSLY DISCLAIM ALL LIABILITIES THAT MAY ARISE AS A
                CONSEQUENCE OF ANY UNAUTHORIZED USE OF CREDIT/ DEBIT CARDS. YOU
                ACKNOWLEDGE THAT THIRD PARTIES MAY PARTNER WITH US FOR PROVISION
                OF SERVICES. WE MAY HAVE FORMED PARTNERSHIPS OR ALLIANCES WITH
                SOME OF THESE THIRD PARTIES FROM TIME TO TIME IN ORDER TO
                FACILITATE THE PROVISION OF CERTAIN SERVICES TO YOU. HOWEVER,
                YOU ACKNOWLEDGE AND AGREE THAT AT NO TIME ARE WE MAKING ANY
                REPRESENTATION OR WARRANTY REGARDING ANY THIRD PARTY'S SERVICES
                NOR WILL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY
                CONSEQUENCES OR CLAIMS ARISING FROM OR IN CONNECTION WITH SUCH
                THIRD PARTY INCLUDING, AND NOT LIMITED TO, ANY LIABILITY OR
                RESPONSIBILITY FOR, DEATH, INJURY OR IMPAIRMENT EXPERIENCED BY
                YOU OR ANY THIRD PARTY. YOU HEREBY DISCLAIM AND WAIVE ANY RIGHTS
                AND CLAIMS YOU MAY HAVE AGAINST US WITH RESPECT TO THIRD PARTY'S
                / MERCHANT’S/ PARTNER’S GOODS OR SERVICES.
              </p>
              <p>
                DISCLAIMS AND ALL LIABILITY THAT MAY ARISE DUE TO ANY VIOLATION
                OF ANY APPLICABLE LAWS INCLUDING THE LAW APPLICABLE TO PRODUCTS
                AND SERVICES OFFERED BY THE MERCHANT ON THE PLATFORM.
              </p>
              <p>
                WHILE THE MATERIALS PROVIDED ON THE PLATFORM WERE PREPARED TO
                PROVIDE ACCURATE INFORMATION REGARDING THE SUBJECT DISCUSSED,
                THE INFORMATION CONTAINED IN THESE MATERIALS IS BEING MADE
                AVAILABLE WITH THE UNDERSTANDING THAT WE MAKE NO GUARANTEES,
                REPRESENTATIONS OR WARRANTIES WHATSOEVER, WHETHER EXPRESSED OR
                IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE,
                QUALITY OF WORK OR OTHER INFORMATION HEREIN. FURTHER, WE DO NOT,
                IN ANY WAY, ENDORSE ANY SERVICE OFFERED OR DESCRIBED HEREIN. IN
                NO EVENT SHALL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY
                DECISION MADE OR ACTION TAKEN IN RELIANCE ON SUCH INFORMATION.
              </p>
              <p>
                YOU EXPRESSLY UNDERSTAND AND AGREE THAT, TO THE MAXIMUM EXTENT
                PERMITTED BY APPLICABLE LAW THE PLATFORM, SERVICES, CONTENT ON
                THE PLATFORM AND OTHER MATERIALS ARE PROVIDED BY COMPANY ON AN
                “AS IS” BASIS WITHOUT WARRANTY OF ANY KIND, EXPRESS, IMPLIED,
                STATUTORY OR OTHERWISE, INCLUDING THE IMPLIED WARRANTIES OF
                TITLE, NON- INFRINGEMENT, MERCHANTABILITY OR FITNESS FOR A
                PARTICULAR PURPOSE. WITHOUT LIMITING THE FOREGOING, COMPANY
                MAKES NO WARRANTY THAT:
              </p>
              <ul>
                <li>
                  THE PLATFORM OR THE SERVICES WILL MEET YOUR REQUIREMENTS OR
                  YOUR USE OF THE PLATFORM OR THE SERVICES WILL BE
                  UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE;
                </li>
                <li>
                  THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE PLATFORM,
                  SERVICES OR CONTENT ON THE PLATFORM WILL BE EFFECTIVE,
                  ACCURATE OR RELIABLE;
                </li>
                <li>
                  THE QUALITY OF THE PLATFORM, SERVICES OR CONTENT ON THE
                  PLATFORM WILL MEET YOUR EXPECTATIONS; OR THAT (IV) ANY ERRORS
                  OR DEFECTS IN THE PLATFORM, SERVICES OR CONTENT ON THE
                  PLATFORM WILL BE CORRECTED. TO THE MAXIMUM EXTENT PERMITTED BY
                  APPLICABLE LAW, COMPANY WILL HAVE NO LIABILITY RELATED TO USER
                  CONTENT ARISING UNDER INTELLECTUAL PROPERTY RIGHTS, LIBEL,
                  PRIVACY, PUBLICITY, OBSCENITY OR OTHER LAWS. COMPANY ALSO
                  DISCLAIMS ALL LIABILITY WITH RESPECT TO THE MISUSE, LOSS,
                  MODIFICATION OR UNAVAILABILITY OF ANY USER CONTENT.
                </li>
              </ul>
              <p>
                WE SHALL NOT BE LIABLE TO YOU OR ANYONE ELSE FOR ANY LOSSES OR
                INJURY ARISING OUT OF OR RELATING TO THE INFORMATION PROVIDED ON
                THE PLATFORM. IN NO EVENT WILL WE OR OUR EMPLOYEES, AFFILIATES,
                AUTHORS OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY
                DECISION MADE OR ACTION TAKEN BY YOUR RELIANCE ON THE CONTENT
                CONTAINED HEREIN.
              </p>
              <p>
                IN NO EVENT WILL WE BE LIABLE FOR ANY DAMAGES (INCLUDING,
                WITHOUT LIMITATION, DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
                CONSEQUENTIAL OR EXEMPLARY DAMAGES, DAMAGES ARISING FROM
                PERSONAL INJURY/WRONGFUL DEATH, AND DAMAGES RESULTING FROM LOST
                PROFITS, LOST DATA OR BUSINESS INTERRUPTION), RESULTING FROM ANY
                SERVICES PROVIDED BY ANY THIRD PARTY OR MERCHANT ACCESSED
                THROUGH THE PLATFORM, WHETHER BASED ON WARRANTY, CONTRACT, TORT,
                OR ANY OTHER LEGAL THEORY AND WHETHER OR NOT WE ARE ADVISED OF
                THE POSSIBILITY OF SUCH DAMAGES.
              </p>
              <h3>17. INTELLECTUAL PROPERTY RIGHTS</h3>
              <p>
                We are either the owner of intellectual property rights or have
                the non- exclusive, worldwide, perpetual, irrevocable, royalty
                free, sub-licensable (through multiple tiers) right to exercise
                the intellectual property, in the Platform, and in the material
                published on it including but not limited to user interface,
                layout format and any content thereof. You recognize that the
                Company is the owner of the logo including but not limited to
                its variants (IPR) as well as the platform name “” and shall not
                directly or indirectly, attack or assist another in attacking
                the validity of, or ’s or its aﬃliates proprietary rights in,
                the licensed marks or any registrations thereof, or ﬁle any
                applications for the registration of the licensed marks or any
                names or logos derived from or confusingly similar to the
                licensed marks, any variation thereof, or any translation or
                transliteration thereof in another language, in respect of any
                products/services and in any territory throughout the world. If
                you become aware or acquire knowledge of any infringement of IPR
                you shall report the same at brand- protection@swiggy.in with
                all relevant information.
              </p>
              <p>
                You may print one copy, and may download extracts, of any
                page(s) from the Platform for your personal reference and other
                material available on the Platform.
              </p>
              <p>
                You must not modify the paper or digital copies of any materials
                you have printed off or downloaded in any way, and you must not
                use any illustrations, photographs, video or audio sequences or
                any graphics separately from any accompanying text.
              </p>
              <p>
                You must not use any part of the materials on the Platform for
                commercial purposes without obtaining a license to do so from us
                or our licensors.
              </p>
              <p>
                If you print, copy or download any part of the Platform in
                breach of these Terms of Use, your right to use the Platform
                will cease immediately and you must, at our option, return or
                destroy any copies of the materials you have made.
              </p>
              <h3>18.THIRD PARTY CONTENT</h3>
              <p>
                We cannot and will not assure that other users are or will be
                complying with the foregoing rules or any other provisions of
                these Terms of Use, and, as between you and us, you hereby
                assume all risk of harm or injury resulting from any such lack
                of compliance.
              </p>
              <p>
                You acknowledge that when you access a link that leaves the
                Platform, the site you will enter into is not controlled by us
                and different terms of use and privacy policy may apply. By
                assessing links to other sites, you acknowledge that we are not
                responsible for those sites. We reserve the right to disable
                links to and / or from third-party sites to the Platform,
                although we are under no obligation to do so.
              </p>
              <h3>19.TREATMENT OF YOUR INFORMATION BY US</h3>
              <p>
                We process information provided by you to us in accordance with
                our Privacy Policy, available here.
              </p>
              <h3>20.SEVERABILITY</h3>
              <p>
                If any of these Terms of Use should be determined to be illegal,
                invalid or otherwise unenforceable by reason of the laws of any
                state or country in which these Terms of Use are intended to be
                effective, then to the extent and within the jurisdiction where
                that term is illegal, invalid or unenforceable, it shall be
                severed and deleted and the remaining Terms of Use shall
                survive, remain in full force and effect and continue to be
                binding and enforceable.
              </p>
              <h3>21.ASSIGNMENT</h3>
              <p>
                You shall not assign or transfer or purport to assign or
                transfer the contract between you and us to any other person.
                Company's rights under the Terms of Use are freely transferable
                by Company to any third parties without the requirement of
                seeking your consent.
              </p>
              <h3>22.GOVERNING LAW</h3>
              <p>
                These Terms of Use are governed by the laws of India. Any
                action, suit, or other legal proceeding, which is commenced to
                resolve any matter arising under or relating to this Platform or
                our Services, shall be subject to the jurisdiction of the courts
                at Bangalore, India.
              </p>
              <h3>23.GRIEVANCE REDRESSAL</h3>
              <p>
                Please contact us at _partnersupport@swiggy.in for any questions
                or comments on abuse or violation of these Terms of Use or if
                you become aware of any objectionable content on the Platform.
              </p>
              <p>
                If you have any concern about the Terms of Use or grievances
                about the Platform or our Services, please address them to our
                grievance officer/nodal officer at: Address: Swiggy Limited
              </p>
              <p>
                Reg Office: No.55, Sy No.8-14, I & J Block, Embassy Tech
                Village, Outer Ring Road, Devarabisanahalli, Bengaluru - 560103
                Phone number: 08067466777 E-mail:partnersupport@swiggy.in
              </p>
              <p>
                We shall endeavour to resolve your grievances within 15
                (fifteen) days from the date of receipt of such grievance.
              </p>
              <h3>24.COMMUNICATIONS</h3>
              <p>
                You agree and grant permission to to send you promotional SMS
                and e-mails from or allied partners. In case you wish to opt out
                of receiving promotional SMS or email please send a mail to
                customercare@.co.in.
              </p>
              <h3>25.WAIVER</h3>
              <p>
                Any failure by Company to enforce or exercise any provision of
                the Terms of Use, or any related right, shall not constitute a
                waiver by Company of that provision or right.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default TermsofUse;
